const Design = {
    colors: {
        pageBackground: "#f2eee9",
        background: "#f9b8af",         // Main background color
        cardBackground: "#f2eee9",     // Card background color
        textPrimary: "#96add6",        // Primary text color
        accentColor1: "#e85234",       // First accent color (orange)
        accentColor2: "#ebe4cb",       // Secondary accent color (purple highlight)
        accentColor3: "#F18572",
        heading: "#d57b0e" ,            // Heading color
        darkBlue: "#00408c",
        blue: "#96add6",
        red: "#e85234",
        peach: "#f9bbaf",
        pink: "#f2d7d3",
        cream: "#f2eee9",
        purple: "#1c1b33",

        color1: "#181624",
        color2: "#4922e5",
        color3: "#a556fb",
        white: "#ffffff",
        black: "#000000",
    },
    spacing: {
        padding: "1.5rem",
        sectionPadding: "2rem"
    },
    borderRadius: "12px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
    boxShadowHover: "0px 8px 15px rgba(0, 0, 0, 0.5)"
};

export default Design;
